import { render, staticRenderFns } from "./Opacity.vue?vue&type=template&id=d8c7e650&"
var script = {}
import style0 from "./Opacity.vue?vue&type=style&index=0&id=d8c7e650&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports